import React from 'react';
import clsx from 'clsx';
import MaskedTextField from 'components/common/MaskedTextField';
import { FieldComponentProps } from 'components/anvilFormFillable/fields/types';
import { placeholderByType } from 'components/anvilFormFillable/utils';

const ssnMask = [{
  mask: '000-00-0000',
  lazy: true,
}];

const einMask = [{
  mask: '00-0000000',
  lazy: true,
}];

export default function TaxpayerNumber({ field, value, onChange }: FieldComponentProps) {
  const mask = /ssn/i.test(field?.type ?? '') ? ssnMask : einMask;
  const placeholder = placeholderByType[field.type];
  return (
    <MaskedTextField
      mask={mask}
      autoFocus
      value={value?.value ?? ''}
      placeholder={placeholder}
      onAccept={(data: string) => {
        onChange?.({ ...value, value: data });
      }}
      className={clsx(' border border-gray-100')}
    />
  );
}
